module.exports = __webpack_public_path__ + "static/media/no_item_in_cart@2x.bd8c4134.png";